import tangcichaxun from "@/components/tangci/tangcichaxun";
import tangcihuizong from "@/components/tangci/tangcihuizong";
import tangciguize from "@/components/tangci/tangciguize";
var data = [
  {
    path: "/tangcichaxun",
    component: tangcichaxun,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/tangcihuizong",
    component: tangcihuizong,
    meta: {
      keepAlive: true
    }
  },
  {
    path: "/tangciguize",
    component: tangciguize
  },
  /*   {
    path: "/rule/gaofeng",
    component: () => import("@/components/rule/ruleGaofeng")
  } */
];
export default data;



// WEBPACK FOOTER //
// ./src/router/tangci.js